import { useState, useEffect, useRef, useCallback } from "react";
import Time from "./Time";
import "./Weather.scss";

const Weather = ({ coordinates = {}, city, limit }) => {
  const [weather, setWeather] = useState({});
  const refreshInterval = useRef(null);

  const lat = coordinates.lat ?? 51.5074; // Default London Lat
  const lng = coordinates.lng ?? -0.1278; // Default London Lng

  const weather_api = `https://api.openweathermap.org/data/2.5/forecast?lat=${lat}&lon=${lng}&cnt=7&units=metric&appid=673bdaae57d0f62db136ef44ee8e3fce`;

  const fetchWeather = useCallback(() => {
    fetch(weather_api)
      .then((response) => response.json())
      .then((data) => setWeather(data))
      .catch((err) => console.log("There was an error accessing the API", err));
  }, [weather_api]);

  useEffect(() => {
    fetchWeather();

    // Refresh every 30 minutes
    refreshInterval.current = setInterval(fetchWeather, 30 * 60 * 1000);

    return () => clearInterval(refreshInterval.current);
  }, [fetchWeather]);

  if (!weather.list) return null;

  const itemsToShow = limit ? weather.list.slice(0, limit) : weather.list;

  const formatDayTime = (unixSeconds) => {
    const date = new Date(unixSeconds * 1000);
    const now = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(now.getDate() + 1);
    const timeStr = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    if (date.toDateString() === now.toDateString()) return `${timeStr}`;
    if (date.toDateString() === tomorrow.toDateString()) return `Tomorrow ${timeStr}`;
    return `${date.toLocaleDateString([], { weekday: "long" })} ${timeStr}`;
  };

  return (
    <div className="banner weather-banner">
      <div className="weather-banner-title">
        <div className="weather-banner-title-location">
          {city ? city : "Weather"}
          <div className="weather-time">
            <Time />
          </div>
        </div>
      </div>

      <div className="weather-banner-items">
        <ul className="weather-list">
          {itemsToShow.map((item, index) => (
            <li key={index} className="weather-list-item">
              {item.weather.map((weather_item) => (
                <div key={weather_item.id} className="weather-icon">
                  <img src={`/img/weather/${weather_item.icon}.png`} alt={weather_item.description} />
                </div>
              ))}

              <div className="weather-details">
                <div className="weather-day">{index === 0 ? "Currently" : formatDayTime(item.dt)}</div>

                {item.weather.map((weather_item) => (
                  <div key={weather_item.id} className="weather-main">
                    {weather_item.description}
                  </div>
                ))}

                <div className="weather-temp">
                  <div className="weather-max-temp">{Math.round(item.main.temp_max)}°C</div>
                  <div className="weather-min-temp">{Math.round(item.main.temp_min)}°C</div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Weather;
